export const ACTING_TENANT_STORAGE_KEY = 'acting-tenant';
export const ACTING_TENANT_HEADER = 'X-Acting-Tenant';

export function readActingTenant(): string {
  try {
    return (localStorage.getItem(ACTING_TENANT_STORAGE_KEY) ?? '').trim();
  } catch {
    return '';
  }
}

export function writeActingTenant(code: string): void {
  try {
    if (!code) {
      localStorage.removeItem(ACTING_TENANT_STORAGE_KEY);
      return;
    }
    localStorage.setItem(ACTING_TENANT_STORAGE_KEY, code);
  } catch {}
}

export function clearActingTenant(): void {
  writeActingTenant('');
}

export function actingTenantHeaders(): Record<string, string> {
  const code = readActingTenant();
  return code ? { [ACTING_TENANT_HEADER]: code } : {};
}
